export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_IS_LOGGEDIN = 'USER_IS_LOGGEDIN'
export const UPDATE_CONTENT = 'UPDATE_CONTENT'
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS'
export const UPDATE_ERROR = 'UPDATE_ERROR'
export const COGNITO_UPDATE_ERROR = 'COGNITO_UPDATE_ERROR'
export const COGNITO_UPDATE_REQUEST = 'COGNITO_UPDATE_REQUEST'